import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as actionsExclusionSubtype from 'action/exclusionSubtype'

import Table from 'component/exclusionSubtype/Table'
import FormModal from 'component/exclusionSubtype/FormModal'
import SideFilterForm from 'component/exclusionSubtype/SideFilterForm'
import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import Button from 'component/Button/index'
import SuccessModal from 'component/Modal/SuccessModal'
import Notification from 'component/utils/Notification'
import FilterIconSVG from 'component/svgComponents/filter'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 10

class ListExclusionSubType extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number,
    current: PropTypes.number,
    pages: PropTypes.number,
    records: PropTypes.array.isRequired,
    menu: PropTypes.object.isRequired,
    logout: PropTypes.any,
    translate: PropTypes.func.isRequired,
    fetchExclusionSubtype: PropTypes.func.isRequired,
    removeExclusionSubtype: PropTypes.func.isRequired,
    saveExclusionSubtype: PropTypes.func.isRequired,
  }

  state = {
    filters: {
      page: DEFAULT_PAGE,
      size: DEFAULT_SIZE,
    },
    selected: {
      all: 0,
      row: Array(DEFAULT_SIZE).fill(0),
    },
    visible: false,
    paginationStyle: {},
    topMargin: 0,
    modalType: false,
    callbackMsg: null,
    data: {},
    sideFilterVisible: false,
    successModalMsg: false,
  }

  componentDidMount() {
    const {
      auth: { user },
      fetchExclusionSubtype,
    } = this.props

    const { filters } = this.state

    fetchExclusionSubtype(user.dsToken, filters)
  }

  handlePagination = (page) => {
    const {
      auth: { user },
      fetchExclusionSubtype,
    } = this.props

    const newFilter = {
      ...this.state.filters,
      page,
      size: DEFAULT_SIZE,
    }

    this.setState({ filters: newFilter }, () => {
      fetchExclusionSubtype(user.dsToken, this.state.filters)
    })
  }

  onFilter = (data) => {
    const {
      auth: { user },
      fetchExclusionSubtype,
    } = this.props

    const { filters } = this.state

    const newFilters = {
      ...filters,
      page: DEFAULT_PAGE,
      size: DEFAULT_SIZE,
      sectionIdList: data.sectionIdList,
      subtypeList: data.subtypeList,
    }

    this.setState({ filters: newFilters, sideFilterVisible: false }, () => {
      fetchExclusionSubtype(user.dsToken, newFilters)
    })
  }

  onRemove = (data) => {
    const {
      auth: { user },
      removeExclusionSubtype,
    } = this.props

    const { filters } = this.state

    const newFilters = {
      ...filters,
      page: DEFAULT_PAGE,
      size: DEFAULT_SIZE,
    }

    removeExclusionSubtype(user.dsToken, data, (data, msg) => {
      this.setState({ successModalMsg: msg, filters: newFilters })
    })
  }

  onSubmit = (data, callback) => {
    const {
      auth: { user },
      saveExclusionSubtype,
    } = this.props
    saveExclusionSubtype(user.dsToken, data, (data, msg) => {
      this.setState({ successModalMsg: msg })
      callback()
    })
  }

  renderSideFilterForm() {
    const { translate, auth } = this.props

    const { sideFilterVisible } = this.state

    return (
      <SideFilterForm
        show={sideFilterVisible}
        initialValues={{}}
        closeFilter={() => this.setState({ sideFilterVisible: false })}
        onSubmit={this.onFilter}
        translate={translate}
        auth={auth}
      />
    )
  }

  render() {
    const {
      translate,
      records,
      pages,
      count,
      current,
      fetchExclusionSubtype,
      auth: { user },
    } = this.props

    const { successModalMsg, filters } = this.state

    return (
      <>
        <div className='new-style'>
          <ContentHeader>{translate('exclusion.subtype.title')}</ContentHeader>

          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              <div className='col-xs-12 col-md-12'>
                <div className='float-right margin-top'>
                  <FormModal
                    translate={translate}
                    onSubmit={this.onSubmit}
                    user={user}
                  />
                  <Button
                    className='btn btn-secondary'
                    text={translate('mobile.filter')}
                    onClick={() => this.setState({ sideFilterVisible: true })}

                    svgIcon
                    svgComponent={
                      <FilterIconSVG className="margin-default-svg" newDesign={false}/>
                    }
                  />
                </div>
              </div>
            </section>
          </div>

          <div className='new-style-table'>
            <Grid fluid className='no-padding'>
              <div className='outer-table new-outer-table'>
                {records.length > 0 ? (
                  <Table
                    records={records}
                    translate={translate}
                    handleDelete={this.onRemove}
                  />
                ) : (
                  <Notification
                    message={translate('no.data.found')}
                    className='notification-warning'
                  />
                )}
              </div>
            </Grid>
            <Row>
              <Col className='align-center margin-bottom'>
                {pages > 1 && (
                  <Pagination
                    getPage={this.handlePagination}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                )}
              </Col>
            </Row>
          </div>
          {this.renderSideFilterForm()}
          {successModalMsg ? (
            <SuccessModal
              t={translate}
              msg={translate(
                `label.exclusion.subtype.success.${successModalMsg}`
              )}
              size='md'
              handleClose={() => {
                this.setState({ successModalMsg: false })
                fetchExclusionSubtype(user.dsToken, filters)
              }}
            />
          ) : (
            ''
          )}
        </div>
      </>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ exclusionSubtypeReducer, paginateReducer }) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  pages: paginateReducer.pages,
  records: exclusionSubtypeReducer.list.records,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionsExclusionSubtype }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    ListExclusionSubType
  )
)

export { ListExclusionSubType }
